(() => {
    class Cart extends App.Entities.Oldpoint {
        constructor() {
            super('carts.usercart');
        }
        get get() {
            let cart = super.get;
            cart.subtotal           = cart.sumGrossListItems;
            cart.total              = cart.cartAmount;
            cart.totalWithDelivery  = cart.cartAmountWithDefaultDeliveryCosts;
            cart.amount             = Object.keys(cart.items).length;
            return cart;
        }
        set get(callback) {
            super.get = cart => {
                if (callback) callback(cart);
            };
        }
    }
    App.Endpoint.Cart = new Cart();
})();
